import { render, staticRenderFns } from "./costReport.vue?vue&type=template&id=ab23db6a&scoped=true"
import script from "./costReport.vue?vue&type=script&lang=js"
export * from "./costReport.vue?vue&type=script&lang=js"
import style0 from "./costReport.vue?vue&type=style&index=0&id=ab23db6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab23db6a",
  null
  
)

export default component.exports